export { default } from './unsupportedProp';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/unsupportedProp/index.js
// module id = 835
// module chunks = 25